<div class="ss-store-box ss-glow-box">
  <ng-content select=".ss-store-box-header">
  </ng-content>
  <ng-content select=".ss-store-box-body">
  </ng-content>
  <ng-content select=".ss-store-box-footer">
  </ng-content>
</div>
